const Constants = {
	USER_STATE: 'USER_STATE'
}

export default Constants